import React, { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import * as styles from "./geofence-list.module.scss";
import { VelavuGeofence } from "velavu-js-api";
import VelavuInput from "../../../../elements/velavu-input";
import IconSearch from "../../../../dynamicicons/icon-search";
import VelavuButton from "../../../../elements/velavu-button";
import IconAdd from "../../../../dynamicicons/icon-add";
import Divider from "../../../../elements/divider";
import GeofenceListItem from "./geofence-list-item";
import whitelabel from "../../../../whitelabel";
import { useHasPermission } from "../../../sign-in-context/sign-in-context";

export interface GeofenceListProps {
	geofences: VelavuGeofence[];
	onSelectGeofence: (id: string) => void;
	onHoverGeofence: (id: string | undefined) => void;
	onCreateGeofence: () => void;
}

export default function GeofenceList(props: GeofenceListProps) {
	const { t } = useTranslation();

	const canWriteGeofences = useHasPermission("geofences:write");

	const [searchText, setSearchText] = useState("");

	const filteredGeofences = useMemo(() => {
		const sanitizedSearchText = searchText.trim().toLowerCase();
		if (sanitizedSearchText === "") {
			return props.geofences;
		} else {
			return props.geofences.filter((geofence) =>
				geofence.name.toLowerCase().includes(searchText),
			);
		}
	}, [props.geofences, searchText]);

	return (
		<React.Fragment>
			<div className={styles.header}>
				<VelavuInput
					className={styles.search}
					leadingIcon={
						<IconSearch
							size={16}
							color={whitelabel.palette.secondary900}
						/>
					}
					placeholder={t("common.search")}
					value={searchText}
					onChange={setSearchText}
					fullWidth
				/>

				{canWriteGeofences && (
					<VelavuButton
						icon={(size, color, className) => (
							<IconAdd
								size={size}
								color={color}
								className={className}
							/>
						)}
						label={t("common.new_geofence")}
						onClick={props.onCreateGeofence}
					/>
				)}
			</div>

			<Divider />

			<div className={styles.list}>
				{filteredGeofences.map((geofence) => (
					<GeofenceListItem
						key={geofence.id}
						geofence={geofence}
						onClick={() => props.onSelectGeofence(geofence.id)}
						onMouseEnter={() => props.onHoverGeofence(geofence.id)}
						onMouseLeave={() => props.onHoverGeofence(undefined)}
					/>
				))}
			</div>
		</React.Fragment>
	);
}
